export default __webpack_public_path__ + "52cdc93a82de20fadd5e94fd559dfcaa.png";